import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import Swiper from "swiper";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import './digitalizeRestaurant.less'

export default {
    name: "digitalizeRestaurant",
    data() {
        return {
			banner: {
				title: '小精灵餐饮',
				subTitle: '构建您的全新数字餐厅!',
				videoAlign: 'right',
				info: '垂直于餐饮业态的线上线下一体化数字经营系统。',
				features: '· 软件&硬件一体化<br>· 公域&私域一体化<br>· 总部&门店一体化<br>· 线上&线下一体化',
				tips: '适合：需要数字化建设的餐饮商家。',
				btnTxt: '',
				btnHref: '',
				btnType: 'href',
				video: 'video/digitalizeRestaurant.webm',
				bg: "#F5A416"//#08CA09 "#67C3C4" #F6AE15 #FE4F1C #6F7BD5 
			},
			solution: {
				title: '小精灵餐饮一体化方案',
				subtitle: '赋能餐饮商户实现公域平台管理、私域会员管理、商品管理、财务管理、前厅管理、外卖管理、库存管理、员工管理等全面数字化经营。',
				pics: [
					{
						pic: 'img/digitalizeRestaurant/solution1.png',
						class: 'num1',
					},
					{
						pic: 'img/digitalizeRestaurant/arrow.png',
						class: 'arrow',
					},
					{
						pic: 'img/digitalizeRestaurant/solution2.png',
						class: 'num2',
					},
					{
						pic: 'img/digitalizeRestaurant/arrow.png',
						class: 'arrow',
					},
					{
						pic: 'img/digitalizeRestaurant/solution3.png',
						class: 'num3',
					}
				]
			},
			intro: {
				title: '餐饮版六大核心亮点',
				subTitle: '通过六大产品矩阵能力，<br>全面实现餐饮的收银数字化 、 会员数字化 、 线上线下数字化 、 连锁数字化。',
				list: [
					{
						type: 'features',
						title:"01.小精灵餐饮SaaS",
						titleBgColor:"#F5A416",
						subTitle: "适合中小型餐饮商户的数字一体化收银SaaS。",
						pic: 'img/digitalizeRestaurant/info1.png',
						imgAlign: '',
						features:"<span class='bit-yello'>·</span>10分钟完成安装，快速上手<br><span class='bit-yello'>·</span>收银&会员一体，高效收银<br><span class='bit-yello'>·</span>线上&线下一体，轻松管店<br><span class='bit-yello'>·</span>扫码点餐&外卖管理一体<br>......"
					},
					{
						type: 'features',
						title:"02.点餐小程序",
						titleBgColor:"#F5A416",
						subTitle: "同时满足堂食、外卖、自提、预点餐等多种点餐场景。",
						pic: 'img/digitalizeRestaurant/info2.png',
						imgAlign: 'right',
						features:"<span class='bit-yello'>·</span>  满足多场景点餐需求<br><span class='bit-yello'>·</span>  自建外卖，大大降低平台扣点成本<br><span class='bit-yello'>·</span>  海量装修模板，颜值更高<br><span class='bit-yello'>·</span>  会员体系/积分/余额,线上线下⽆缝打通<br><span class='bit-yello'>·</span>  点餐和库存商品同步<br>......"
					},
				],
				list2:[
					{
						type: 'list',
						title:"03.私域会员体系",
						titleBgColor:"#F5A416",
						subTitle: "全链路会员生命周期运营，实现门店私域会员高效增长。",
						pic: '',
						imgAlign: '',
						featureList: [
							{
								title: "1.连接客户",
								pic: 'img/digitalizeRestaurant/info3.png',
								imgAlign:'',
								featuresColor: "#068CF9",
								features: "·3秒开卡 <br>·小程序点单 <br>·加客户企业微信 <br>·微信社群"
							},
							{
								title: "2.创造价值",
								pic: 'img/digitalizeRestaurant/info4.png',
								imgAlign:'right',
								featuresColor: "#068CF9",
								features: "·会员权益<br>·储值  <br>·优惠活动 <br>·商城、外卖、直播 <br>·亲子活动/亲子私房菜<br>·相亲会、生日会..."
							},
							{
								title: "3.深化关系",
								pic: 'img/digitalizeRestaurant/info5.png',
								imgAlign:'',
								featuresColor: "#068CF9",
								features: "·形成朋友圈互动 <br>·微信群互动 <br>·顾客评价 <br>·菜(商)品体验官<br>·品鉴会 <br>·产品分销"
							},
							{
								title: "4.赋能门店",
								pic: 'img/digitalizeRestaurant/info6.png',
								imgAlign:'right',
								featuresColor: "#068CF9",
								features: "·激励店长<br>·激励员工<br>·赋能店员<br>·赋能门店增长"
							},
						]
					},
					{
						type: 'banner',
						pic: 'img/digitalizeRestaurant/info_banner1.png',
					},
					{
						type: 'vip',
						title:"04.公域平台打通",
						titleBgColor:"#F5A416",
						subTitle: "打通抖音、美团、点评等公域平台，玩转“公转私”。",
						item1:{
							pic: 'img/digitalizeRestaurant/vip1.png',
							btnTxt: '公域平台会员',
							btnLink: '',
							btnType: 'herf'
						},
						item2:{
							pic: 'img/digitalizeRestaurant/vip2.png',
							btnTxt: '门店私域会员',
							btnLink: '',
							btnType: 'herf'
						},
						arrow: 'img/digitalizeRestaurant/vip_arrow.png',
					},
					{
						type: 'features',
						title:"05.移动管家APP",
						titleBgColor:"#F5A416",
						subTitle: "收银员在手机端即可实现收银、会员、菜品管理等，管店效率更高。",
						pic: 'img/digitalizeRestaurant/info7.png',
						imgAlign: 'right',
						features:"<span class='bit-blue'>·</span> 门店业务，一手掌握<br><span class='bit-blue'>·</span> 网店业务，移动管理<br><span class='bit-blue'>·</span> 移动端实时菜品管理<br><span class='bit-blue'>·</span> 移动端轻松会员管理<br>......"
					},
				],
				list4:[
					{
						type: 'icon-list',
						title:"07.多种收银硬件设备",
						titleBgColor:"#F5A416",
						subTitle: "搭配适合各种餐厅的硬件设备，与小精灵收银软件完美适配，为门店生意提供最合适的选择。",
						pic: '',
						imgAlign: '',
						featureStyle: "row",
						featureList: [
							{
								title: "双屏收银设备",
								subTitle: "适合咖啡厅、西餐、新式中餐、特色餐饮、潮牌茶饮",
								pic: 'img/digitalizeRestaurant/info8.png',
							},
							{
								title: "单屏收银设备",
								subTitle: "适合烘焙、茶饮、咖啡厅、新式中餐、特色餐饮",
								pic: 'img/digitalizeRestaurant/info9.png',
							},
							{
								title: "卧式收银设备",
								subTitle: "适合对性价比要求高的中小型餐饮店",
								pic: 'img/digitalizeRestaurant/info10.png',
							},
							{
								title: "智能称重设备",
								subTitle: "适合卤味、熟食、炒货等称重型餐饮店",
								pic: 'img/digitalizeRestaurant/info11.png',
							},
							{
								title: "平板收银设备",
								subTitle: "适合中小型咖啡、茶饮、西餐、特色餐饮",
								pic: 'img/digitalizeRestaurant/info12.png',
							},
							{
								title: "手持收款设备",
								subTitle: "适合小型档口店、夫妻店、街边店",
								pic: 'img/digitalizeRestaurant/info13.png',
							},
							{
								title: "刷脸支付设备",
								subTitle: "适合校园食堂、团餐、档口店",
								pic: 'img/digitalizeRestaurant/info14.png',
							},
							{
								title: "语音收款播报设备",
								subTitle: "适合小型夫妻店、街边店",
								pic: 'img/digitalizeRestaurant/info15.png',
							},
						]
					},
				]
			},
			intro6:{
				title: '06.细分场景解决方案',
				subTitle: '快餐&简餐 · 茶饮 · 烘焙 · 特色餐饮&新式中餐焙 · 美食城&团餐',
				titleBgColor:"#F5A416",
				currentColor:"#4386E9",
				currentIndex: 0,
				pic: 'img/digitalizeRestaurant/group1.png',
				list: [
					{
						title:"快餐&简餐 →",
						pic: 'img/digitalizeRestaurant/group1.png',
						txt:"主要通过点餐小程序和移动收银台，带来快速便捷的就餐体验。"
					},
					{
						title:"茶饮 →",
						pic: 'img/digitalizeRestaurant/group2.png',
						txt:"通过自提&外卖小程序集合企业微信与员工分销，助力产业轻松实现订单增长。"
					},
					{
						title:"烘焙 →",
						pic: 'img/digitalizeRestaurant/group3.png',
						txt:"收银SaaS结合商城小程序，通过拼团/秒杀、储值分销等系列玩法，实现业绩增长。"
					},
					{
						title:"特色餐饮&新式中餐 →",
						pic: 'img/digitalizeRestaurant/group4.png',
						txt:"收银SaaS与商品进销存管理、智能厨房系统，结合付费会员+员工分销，中餐也能潮起来。"
					},
					{
						title:"美食城&团餐 →",
						pic: 'img/digitalizeRestaurant/group5.png',
						txt:"多样智能收款设备，结合多门店储值一卡通，通过多门店分账能力，提高美食城收款和管理能效。"
					},
				]
			},
            rollList: [
                {
                    src: "/img/digitalizeRestaurant/roll1.png",
                    size: 2,
                },
                {
                    src: "/img/digitalizeRestaurant/roll2.png",
                    size: 2,
                },
                {
                    src: "/img/digitalizeRestaurant/roll3.png",
                    size: 1,
                },
                {
                    src: "/img/digitalizeRestaurant/roll4.png",
                    size: 3,
                },
            ],
			brand: [
				'img/digitalizeOverview/brand1.png',
				'img/digitalizeOverview/brand2.png',
				'img/digitalizeOverview/brand3.png',
				'img/digitalizeOverview/brand4.png'
			]
        }
    },
    components: {
        skeleton,
        pay,
        QRCode,
        vueSeamlessScroll
    },
	mounted(){
		this.$nextTick( () => {
			let clientWidth = document.documentElement.clientWidth;
			let slideCount = 5;
			if(clientWidth <= 1036){
				slideCount = 1;
			}
			
			new Swiper ('.swiper-solution', {
				// 如果需要滚动条
				// scrollbar: '.swiper-scrollbar',
				//如果需要自动切换海报
				autoplay: {
					delay: 0,
					stopOnLastSlide: false,
					disableOnInteraction: false,
				},
				speed: 8000,
				loop: true,
				slidesPerView: slideCount,
				spaceBetween: 30,
				centeredSlides: true,
				// pagination: {
				// 	el: '.swiper-pagination',
				// 	clickable: true
				// }
			})
		})
		
		// document.addEventListener('touchstart', function () {
		// 	document.getElementById('wapVideo').play();
		// },2000);
	},
    methods: {
		infoMouseOver(index){
			this.intro6.currentIndex = index
			this.intro6.pic = this.intro6.list[index].pic
		}
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        }
    }
}
